export default String.raw`
if ($('.customer-profile-content-js').length > 0) {
    $(document).ready(function () {
        customerProfile.init();
    });
}

const customerProfile = {
    hiddingClass: 'hidden-js',

    init: function () {
        this.events();

        if ($('.load-erp-data-js').length > 0 || document.getElementsByClassName("orders-js").length > 0 || document.getElementsByClassName("discounts-js").length > 0) {
            erpDataDownloading();
        }

        if ($('.customer-profile-content-js').length > 0) {
            app.customerProfileRouting.updateTabFromUrl();
        }
    },

    events: function () {
        const body = $('body');

        body.on('change', '[name="newsletter"]', function () {
            customerProfile.changeNewsletterForm(this, '.newsletter-subscribe-form-js', '.newsletter-unsubscribe-form-js');
        });

        // current employee (account) data update
        body.on('click', '.employee-update-trigger-js', function (e) {
            e.preventDefault();
            customerProfile.editEmployeeData('.employee-data-form-js', '.toggle-newsletter-js', '.newsletter-subscribe-form-js', '.newsletter-unsubscribe-form-js', function (_res1, res2) {
                $('.close-js').trigger('click');
                if (res2[0].action) {
                    var message = res2[0].action.Message;
                    $('.promises-message-js').html(
                        '<div class="message-bar">'+
                        message +
                        '</div>'
                    );
                    setTimeout(function () { $('.promises-message-js').html(''); }, 8000);
                }
            });
        });

        body.on('click', '.set-focus-trap-js', function(e) {
            setTimeout(() => {
                const popup = $('.message-popup-background');
                const closeButton = popup.find('.cancel-js');
                const closeFunction = () => closeButton.trigger('click');
                app.setLockFocus(popup, closeFunction, $(e.currentTarget));
            }, 1000);
        });
    
        body.on('click', '.change-email-trigger-js', function (e) {
            e.preventDefault();
            customerProfile.emailChange(".email-form-js", e, ".close-js", '.popup-messages-container');
        });

        body.on('click', '.change-password-trigger-js', function (e) {
            e.preventDefault();
            customerProfile.passwordChange(".password-form-js", e, ".close-js", '.popup-messages-container');
        });

        body.on('click', '.cancel-order-js', function () {
            customerProfile.showConfirmCancelOrderPopup('.confirmation-popup-js', 'hidden-js');
        });
        body.on('click', '.confirmation-popup-js.order-cancel-js .yes-js', function (e) {
            e.preventDefault();
            $('.cancel-order-js').addClass('post-js').click();
        });

        body.on('click', '.cancel-complaint-js', function (e) {
            e.preventDefault();
            customerProfile.showConfirmCancelComplaintPopup('.confirmation-popup-js', 'hidden-js');
        });
        body.on('click', '.confirmation-popup-js.complaint-cancel-js .yes-js', function (e) {
            e.preventDefault();
            $('.cancel-complaint-js').addClass('post-js replace-url-js').click();
        });

        body.on('click', '.edit-data-change-popup-js', function (e) {
            e.stopPropagation();
            $(e.currentTarget).parent().find('.employee-data-edit').slideToggle(400, 'linear');
        });

        body.on('click', '.customer-profile-content-js [data-url]', function (e) {
            e.preventDefault();
            const newUrl = $(this).data('url');
            if (newUrl) {
                window.history.replaceState(null, "", app.historyUrl(newUrl));
            }
            app.customerProfileRouting.updateTabFromUrl();
        });

        body.on("change", '.toggle-button input[type="checkbox"]', function() {
            const label = $(this).next('label[role="switch"]');
            if ($(this).is(':checked')) {
                label.attr('aria-checked', 'true');
            } else {
                label.attr('aria-checked', 'false');
            }
        });
    },

    //change newsletter form depending on check
    changeNewsletterForm: function (toggleNewsletterCheck, newsletterSubFormSelector, newsletterUnsubFormSelector) {
        var isChecked = $(toggleNewsletterCheck).prop('checked');
        if (isChecked) {
            $(newsletterSubFormSelector).removeClass(this.hiddingClass);
            $(newsletterUnsubFormSelector).addClass(this.hiddingClass);
        } else {
            $(newsletterSubFormSelector).addClass(this.hiddingClass);
            $(newsletterUnsubFormSelector).removeClass(this.hiddingClass);
        }
    },

    //employee data form update
    editEmployeeData: function (dataFormSelector, toggleNewsletterCheck, newsletterSubFormSelector, newsletterUnsubFormSelector, callback) {
        var dataForm = $(dataFormSelector);

        //html5 based validation (onyx validation can't be called here)
        var nameInput = dataForm.find('[name="name"]');
        if (nameInput.val() == '') {
            nameInput.siblings('.validation-required-js').removeClass(this.hiddingClass);
            return;
        }

        var name2Input = dataForm.find('[name="name2"]');
        if (name2Input.val() == '') {
            name2Input.siblings('.validation-required-js').removeClass(this.hiddingClass);
            return;
        }

        var employeeData = dataForm.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
        employeeData.push({name: "__csrf", value: __CSRF});
        var employeePromise = window.UIFeatures.makePostRequest(employeeData);
        var isSubscriber = $(toggleNewsletterCheck).data('is-subscriber');
        var newsletterCheck = $(toggleNewsletterCheck).prop('checked');
        var newsletterData = null;
        var newsletterPromise = null;
        var newsletterValidity = false;

        if (isSubscriber && !newsletterCheck) {
            var newsletterForm = $(newsletterUnsubFormSelector);
            if (newsletterForm.get(0).checkValidity()) {
                newsletterValidity = true;
                newsletterData = newsletterForm.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            }
        } else if (!isSubscriber && newsletterCheck) {
            var newsletterForm = $(newsletterSubFormSelector);
            if (newsletterForm.get(0).checkValidity()) {
                newsletterValidity = true;
                newsletterData = newsletterForm.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            }
        } else {
            newsletterValidity = true;
        }

        if (newsletterForm && !newsletterForm.hasClass(this.hiddingClass) && !newsletterValidity) {
            var tosList = newsletterForm.find('[name="tos"]');
            var thisRef = this;
            tosList.each(function () {
                if (this.validity.valueMissing) {
                    $(this).siblings('.validation-required-js').removeClass(thisRef.hiddingClass);
                }
            });
            return;
        }

        if(newsletterForm != undefined){
            var error = false;
            var channels = newsletterForm.find('[name=channelKey]');
            channels.each(function () {
                var channelParent = $(this).parent().parent();
                var tos = channelParent.find('[name=tos]');
                const isRequired = $(this).prop('required');
                const isStatement = channelParent.hasClass('statement-js');
                const tosExists = tos != undefined;
                const tosCheckedOrRequired = tosExists && (tos.prop('checked') || tos.prop('required'));
                if(isRequired || isStatement || tosCheckedOrRequired){
                    var channelsInCurrentTos = channelParent.find('[name=channelKey]');
                    var nothingSelected = true;
                    channelsInCurrentTos.each(function () {
                        if($(this).prop('checked')){
                            nothingSelected = false;
                        }
                    });
                    if(nothingSelected){
                        channelParent.find('.validation-channel-js').removeClass('hidden-js');
                        error = true;
                    }
                }
            });

            if(error){
                return;
            }
        }

        var promise = null;
        if (newsletterData) {
            newsletterData.push({name: "__csrf", value: __CSRF});
            var newsletterPromise = window.UIFeatures.makePostRequest(newsletterData);
            promise = $.when(employeePromise, newsletterPromise);
        } else {
            promise = employeePromise;
        }

        promise.then(function (res1, res2) {
            if (callback) {
                callback(res1, res2);
            }
        });
    },

    passwordChange: function(formSelector, e, closeTrigger, messagesContainerSelector, callback) {
        var isValid = window.app.validationBeforePost(e) === "";
        if (isValid) {
            var formData = $(formSelector).find("input:not([disabled]), select:not([disabled]), textarea:not([disabled])").serializeArray();
            formData.push({
                name: "__csrf",
                value: __CSRF
            });

            window.UIFeatures.makePostRequest(formData).then(function(res) {
                var messageType = res.action.Type;
                var message = res.action.Message;
                app.temporaryPopupMessage(undefined, message, messageType);
    
                setTimeout(function() {
                    $(messagesContainerSelector).find('.popup-in-form').fadeOut(600, function() {
                        $(this).remove();
                    });
                }, 8000);
    
                $(closeTrigger).trigger("click");

                if (callback) {
                    callback(res);
                }
            });
        }
        if (!isValid && callback) {
            callback(null);
        }
    },

    emailChange: function(formSelector, e, _closeTrigger, messagesContainerSelector, callback) {
        var isValid = window.app.validationBeforePost(e) === "";
        if (isValid) {
            var formData = $(formSelector).find("input:not([disabled]), select:not([disabled]), textarea:not([disabled])").serializeArray();
            formData.push({
                name: "__csrf",
                value: __CSRF
            });
    
            window.UIFeatures.makePostRequest(formData).then(function(res) {
                var messageType = res.action.Type;
                var message = res.action.Message;
                app.temporaryPopupMessage(undefined, message, messageType);
    
                setTimeout(function() {
                    $(messagesContainerSelector).find('.popup-in-form').fadeOut(600, function() {
                        $(this).remove();
                    });
                }, 8000);
                $(".cancel-js").trigger("click");
    
                var newEmail = formData[1].value;
                $(".email-container").text(newEmail);
    
                if (callback) {
                    callback(res);
                }
            });
        }
        if (!isValid && callback) {
            callback(null);
        }
    },

    showConfirmCancelOrderPopup: function(popupSelector, hiddingClass) {
        var popup = $(popupSelector);
        popup.addClass('order-cancel-js');
        popup.removeClass(hiddingClass);
        
        const closeFunction = () => {
            popup.find('.no-js').click();
        }
        app.setLockFocus(popup, closeFunction, $(document.activeElement));
    },

    cancelOrder: function (e) {
        window.app.post(e);
    },

    showConfirmCancelComplaintPopup: function(popupSelector, hiddingClass) {
        var popup = $(popupSelector);
        popup.addClass('complaint-cancel-js');
        popup.removeClass(hiddingClass);
    },

    cancelComplaint: function(e) {
        window.app.post(e);
    }
};

// complaint form
function openComplaintForm(e) {
    const button = e.target;
    const formType = button.getAttribute('data-type');
    const productUrl = button.dataset.product;  
    const productContainer = button.closest('td');
    const formContainer = document.querySelector('.opening-modal-js.complaint-form-js[data-type="' + formType + '"][data-product="' + productUrl + '"] ');

    formContainer.dataset.product = productUrl;

    const openDropdownTriggers = $('.close-dropdown-js');
    if (openDropdownTriggers.length) {
        openDropdownTriggers.each((_, element) => {
            app.closeDropdown($(element));
        });
    }

    if (formContainer) {
        const hiddenContainer = formContainer.querySelector('.container-to-hide-js');

        if (hiddenContainer) {
            hiddenContainer.querySelector('.form-js').classList.remove('hidden-js');
            hiddenContainer.querySelector('.success-message-js').classList.add('hidden-js');
            const mainHeader = hiddenContainer.querySelector(':scope > .data-form__header');
            if (mainHeader) {
                mainHeader.classList.remove('hidden-js');
            }
            hiddenContainer.classList.remove('hidden-js');

            const accountNumberInput = hiddenContainer.querySelector('input[name="accountNumber"]');
            if (accountNumberInput) {
                accountNumberInput.value = '';
                accountNumberInput.classList.remove('validation-error-js');
                const accountWrapper = accountNumberInput.closest('.account-number-wrapper-js');
                if (accountWrapper) {
                    const validationInfo = accountWrapper.querySelector('.validation-required-js');
                    if (validationInfo) {
                        validationInfo.classList.add('hidden-js');
                    }
                    const inputInfo = accountWrapper.querySelector('.form__input-info');
                    if (inputInfo) {
                        inputInfo.classList.remove('validation-error');
                    }
                }
            }
        }

        const quantityChangeElem = productContainer.querySelector('.order-editing-quantity-change-js');
        if (quantityChangeElem) {
            quantityChangeElem.classList.add('change-quantity-js');
            quantityChangeElem.classList.remove('order-editing-quantity-change-js');
        }

        const quantityElem = productContainer.querySelector('.order-editing-quantity-js');
        if (quantityElem) {
            quantityElem.classList.remove('order-editing-quantity-js');
        }

        let quantity = hiddenContainer.querySelector('[name="quantity"]');
        const orderId = hiddenContainer.querySelector('[name="orderId"]').value;
        const no = hiddenContainer.querySelector('[name="no"]').value;

        if (quantity) {
            if (window.complaints && window.complaints[orderId] && window.complaints[orderId][no] != null) {
                const val = window.complaints[orderId][no];
                quantity.value = val;
                quantity.dataset.max = val;
                hiddenContainer.querySelector('.max-js').innerHTML = val;
                quantity.nextElementSibling.classList.add('disabled-js');
                quantity.nextElementSibling.disabled = true;
                if (Number(val) !== 1) {
                    quantity.previousElementSibling.classList.remove('disabled-js');
                    quantity.previousElementSibling.disabled = false;
                }
            }
        } else {
            quantity = hiddenContainer.querySelector('.amount-stepper-container-js').dataset.quantity;
        }
    }
}

js.delegate(document.body, 'click', '.open-complaint-form-js', openComplaintForm);

$('body').on('click', '.add-complaint-form-js', function (e) {
    e.stopPropagation();
});

function findPointsProducts(e) {
    $.get('',
        {
            __csrf: __CSRF,
            __action: 'Get/SearchAdvanced',
            flags: 1024
        }
    ).then(function (res) {
        location.href = res.action.Redirect302;
    });
};

$('body').on('click', '.find-products-with-points-js', function(e) {
    findPointsProducts(e);
});

function setReminderDate(e) {
    const container = $('.after-adding-to-wishlist-popup-js .after-adding-to-cart-popup-container-js');
    const error = container.find('.validation-required-js');
    const val = $('[name="notifyDate"]').val();
    if(val == ""){
        error.removeClass('hidden-js');
        $('[name="notifyDate"]').addClass('validation-error');
    } else {
        $('[name="notifyDate"]').removeClass('validation-error');
        const message = $(e.currentTarget).data('success');
        const date = val + ' 06:00:00';
        let productId;
        let parameters = null;
        if($('[name=productType]').val() == 'simple'){
            productId = $('[data-product-id]').data('product-id');
        } else {
            const products = window.childs;
            for (const product of products) {
                if (product.askForPriceChild === false && product.quantity > 0) {
                    let supplyId;
                    if ($('[name="productType"]').val() == 'batch') {
                        supplyId = $('[data-product-id]').data('product-id');
                    } else {
                        supplyId = product.supply;
                    }
                    const parameter = { productId: supplyId, notify: true, notifyDate: date };
                    if (parameters) {
                        parameters.push(parameter);
                    } else {
                        parameters = [parameter];
                    }
                }
            }
        }
        let data = {
            productId: productId,
            notify: true,
            notifyDate: date,
            __csrf: __CSRF,
            __action: 'Product/WishListUpdate'
        };
        if(parameters){
            data = {
                __parameters:JSON.stringify(parameters),
                __csrf: __CSRF,
                __action: 'Product/WishListUpdate'
            };
        }
        $.post(null, data, function () {
            $('.after-adding-to-wishlist-popup-js .after-adding-to-cart-popup-container-js > *').addClass('hidden-js');
            app.temporaryMessage(container, message);
            setTimeout(function(){
                $('.after-adding-to-wishlist-popup-js').addClass('hidden-js');
                $('.after-adding-to-wishlist-popup-js .after-adding-to-cart-popup-container-js > *').removeClass('hidden-js');
            }, 3300);
        });
    }
};

$('body').on('click', '.set-reminder-date-js', function(e) {
    setReminderDate(e);
});

function updateReminderDate(e) {
    const inputVal = $(e.currentTarget).val();

    function isFutureDate(dateStr) {
        if (dateStr === "") {
            return false;
        }
        const chosenDate = new Date(dateStr + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return chosenDate > today;
    }

    if (__isB2B == 'true') {
        const wishListId = $('.wishlist-global-container-js input[name="wishlistId"]').val();
        const url = $('.wishlist-global-container-js').data('url');

        let finalDate = "";
        if (inputVal !== "" && isFutureDate(inputVal)) {
            finalDate = inputVal + ' 06:00:00';
        }
        const data = {
            __csrf: __CSRF,
            __action: 'Wishlist/SetNotifyDate',
            __template: 'static-elements/wishlist-details/wishlist-details.html',
            id: wishListId,
            date: finalDate
        };

        $.post(url, data, function(res) {
            if (res.action.Result) {
                $('.wishlist-global-container-js').replaceWith(res.template);
            }
        });
    } else {
        const productId = $(e.currentTarget).data('id');
        const data = {
            productId: productId,
            __csrf: __CSRF,
            __action: 'Product/WishListUpdate'
        };
        if (inputVal !== "" && isFutureDate(inputVal)) {
            const date = inputVal + ' 06:00:00';
            data.notify = true;
            data.notifyDate = date;
        } else {
            data.notify = false;
        }
        $.post(null, data);
    }
};

$('body').on('change', '.update-reminder-date-js', function(e) {
    updateReminderDate(e);
});

$('body').on('click', '.open-wishlist-details-js', function(e) {
    e.preventDefault();
    const wishListId = $(e.currentTarget).data('wishlist-id');
    const wishListQuery = $(e.currentTarget).closest('table').data('wishlist-query');
    const url = $(e.currentTarget).closest('table').data('wishlist-details-url');
    const data = {
        __csrf: __CSRF,
        __template: 'static-elements/wishlist-details/wishlist-details.html',
        [wishListQuery]: wishListId
    }
    $.get(url, data, function (result) {
        $('.wishlist-global-container-js').replaceWith(result.template);
        window.history.replaceState(null, null, app.historyUrl(url + '&' + wishListQuery + '=' + wishListId));
    });
});

$('body').on('click', '.delete-product-from-wishlist-js', function(e) {
    if (__isB2B == 'true') {
        const url = $('.wishlist-global-container-js').data('url')
        const productId = $(e.currentTarget).closest('.wishlist-product-container').data('product-id');
        const data = {
            __csrf: __CSRF,
            __template: 'static-elements/wishlist-details/wishlist-details.html',
            __action: 'Wishlist/ProductDelete',
            id: productId
        }
        $.post(url, data, function(res) {
             if(res.action.Result && res.template) {
                $('.wishlist-global-container-js').html(res.template);
            }
        });
    } else {
        app.post(e, deleteWishlistProduct, e, '.products-list-js');
    }
});

function deleteWishlistProduct() {
    if ($('.container-to-delete-js').length === 0) {
        const info = '<div class="no-data">' + __translations.yourWishListIsEmpty + '</div>';
        $('.wishlist-container-js').html(info);
        $('.wishlist-icon-js').html('');
        $('.wishlist-icon-container-js a').addClass('toggle-dropdown-js');
    }
};

$('body').on('click', '.prepare-delete-wishlist-popup-js', function(e) {
    e.stopPropagation();
    const wishListPopup = $('.delete-wishlist-popup-js');
    if(!$(e.currentTarget).hasClass('delete-from-wishlist-details-js')) {
        const wishListContainer = $(e.currentTarget).closest('.wishlist-item-container');
        const wishListName = wishListContainer.data('wishlist-name');
        const wishListId = wishListContainer.data('wishlist-id');
        wishListPopup.find('input').val(wishListId);
        wishListPopup.find('strong').text(wishListName);
    }
    wishListPopup.removeClass('hidden-js');
    app.activateFocusTrap('.delete-wishlist-popup-js', e.currentTarget);
    app.closePopupOnEscape(wishListPopup, 'hide-container-js', $('.open-dropdown-js, close-dropdown-js'));
});

$('body').on('click', '.delete-wishlist-js', function(e) {
    const wishListId = $('.delete-wishlist-popup-js input').val();
    let url = $(e.currentTarget).data('url');
    if(!url) {
        url = '';
    }
    const data = {
        __csrf: __CSRF,
        __action: 'Wishlist/Delete',
        __template: 'static-elements/wishlist/wishlist.html',
        id: wishListId
    }
    $.post(url, data, function(res) {
        if(res.action.Result) {
            $('.wishlist-global-container-js').replaceWith(res.template);
        }
        app.selects($('.wishlist-global-container-js'));
    });
});

$('body').on('click', '.add-new-wishlist-in-cp-js', function(e) {
    document.getElementsByClassName('add-new-wishlist-popup-js')[0].classList.remove('hidden-js');
    app.activateFocusTrap('.add-new-wishlist-popup-js', e.currentTarget);
});

const wishlistToCart = async (wishListId, cartId, inquiry = false) => {
    // Max products to copy limited to 80.
    const data = {
        __csrf: __CSRF,
        __action: 'Wishlist/AddToCart',
        __template: 'partials/common/header/client-area.html',
        wisId: wishListId
    };
    
    // Only B2B
    if (cartId) {
        data.cartId = cartId;
    }

    try {
        const response = await $.post(null, data);
        $('.client-area-js').html(response.template);
        const products = response?.action?.Products;
        const notAddedProducts = response?.action.Results;

        if (products?.length > 0) {
            if (inquiry) {
                window.dispatchEvent(new CustomEvent('inquiry:added', {
                    detail: {
                        products: products,
                        failure: notAddedProducts?.length > 0
                    }
                }));
            } else {
                let strategy = __aatc;
                if (notAddedProducts?.length > 0) {
                    strategy = "2";
                }
                window.dispatchEvent(new CustomEvent('cart:added', {
                    detail: {
                        products: products,
                        strategy: strategy
                    }
                }));
            }
        }

        const isSingleProductNotAdded =  (!response?.action.Result && response?.action?.Object);
        if (isSingleProductNotAdded || notAddedProducts?.length > 0) {
            let title;
            if (inquiry) {
                title = __translations.NotAddedToInquiry;
            } else {
                title = __translations.NotAddedToCart;
            }
            window.dispatchEvent(new CustomEvent('validation:failure', {
                detail: {
                    title: title,
                    results: response.action.Results || [response.action]
                }
            }));
            return;
        }

        if(response?.action.Code != 0) {
            app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
            return;
        }
    } catch (error) {
        console.error('Failed to copy wishlist to Cart/Inquiry: ', error);
    }
}

$('body').on('click', '.add-all-to-cart-from-wishlist-js, .add-all-to-inquiry-from-wishlist-js', withSpinner(async (e) => {
    if($('.can-add-js').length > 0) {
        const wishListId = $('input[name="wishlistId"]').val();
        let isInquiry = false;
        let cartId = null;

        if ($(e.currentTarget).hasClass('add-all-to-inquiry-from-wishlist-js')) {
            isInquiry = true;

            const activeInquiryId = app.getCookie('activeInquiryId');
            if (activeInquiryId == -1 || activeInquiryId == '') {
                const response = await $.post('', { __action: 'Cart/Create', inquiry: true, __csrf: __CSRF });
                cartId = response.action.Object.CartId;
            } else {
                cartId = activeInquiryId;
            }
        } 

        await wishlistToCart(wishListId, cartId, isInquiry);
        changeHeaderCart();
        app.setCartDropdownList();
        const popup = document.querySelector('.after-adding-to-inquiry-popup-js, .validation-popup-js');
        const keydownHandler = (event) => {
            if (event.key === 'Escape' || event.target.classList.contains('close-js')) {
                const buttonToFocus = event.currentTarget.parentElement.querySelector('button.pure-button');
                const timeOut = setTimeout(() => {
                    buttonToFocus.focus();
                    clearTimeout(timeOut);
                    popup.removeEventListener('keydown', keydownHandler);
                });
            }
        };
        popup.addEventListener('keydown', keydownHandler);
    }
}));

$('body').on('click', '.change-wishlist-name-js', function (e) {
    const wishlistId = $(e.currentTarget).data('wishlist-id');
    const currentName = $(e.currentTarget).data('wishlist-name');
    const popup = $('.change-wishlist-popup-js');
    popup.find('input[name="wishlistId"]').val(wishlistId);
    popup.find('input[name="wishlistName"]').val(currentName);
    popup.removeClass('hidden-js');
    app.formLabelAnimationOnLoadPage();
    app.activateFocusTrap('.change-wishlist-popup-js', e.currentTarget);
    app.closePopupOnEscape(popup, 'hide-container-js', $('.open-dropdown-js, close-dropdown-js'));
});

$('body').on('click', '.save-wishlist-popup-js', function () {
    const popup = $(this).closest('.change-wishlist-popup-js');
    const wishListId = popup.find('input[name="wishlistId"]').val();
    const newWishListName = popup.find('input[name="wishlistName"]').val();

    if (!wishListId) {
        console.error("Wishlist ID is missing!");
        alert('{{ translations.IdMissingError }}');
        return;
    }

    const url = $('.wishlist-global-container-js').data('url');
    const data = {
        __csrf: __CSRF,
        __template: 'static-elements/wishlist-details/wishlist-details.html',
        __action: 'Wishlist/ChangeName',
        id: wishListId,
        name: newWishListName
    };

    $.post(url, data, function (res) {
        if (res.action.Result) {
            $('.wishlist-global-container-js').replaceWith(res.template);
            popup.addClass('hidden-js');
        } else {
            app.temporaryPopupMessage(undefined, res.action.Message, 'err');
        }
    });
});

function autoSaveHeaderAttributesInProfile() {
    let isValid = true;
    const inputs = $('.header-attributes-set-form-js [name="attribute"]');

    inputs.each(function(){
        if($(this).prop('required') && $(this).val() == ''){
            isValid = false;
            return false
        }
    });
    if(isValid){
        $('.header-attributes-set-form-js .form-error-js').remove();
        const data = $('.header-attributes-set-form-js').find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
        data.push({ name: '__csrf', value: __CSRF });
        data.push({ name: '__template', value: 'partials/customer-profile/orders/order-details.html' });
        if($('[data-current]').index() != -1){
            const page = $('[data-current]').data('current');
            if(window.editOrder.orderRequestUrl.indexOf('orderDetPageId='+page) === -1){
                if(window.editOrder.orderRequestUrl.indexOf('orderDetPageId') !== -1){
                    window.editOrder.orderRequestUrl = window.editOrder.orderRequestUrl.substring(0, window.editOrder.orderRequestUrl.indexOf('&orderDetPageId')) + '&orderDetPageId=' + page;
                } else {
                    window.editOrder.orderRequestUrl = window.editOrder.orderRequestUrl + '&orderDetPageId=' + page;
                }
            }
        }

        $.post(window.editOrder.orderRequestUrl, data, function(res){
            $('.customer-profile-content-js').html(res.template);
        });
    }
};

$('body').on('change', '.customer-profile-content-js .header-attributes-set-form-js [name="attribute"]', function() {
    autoSaveHeaderAttributesInProfile();
});

if(window.innerWidth <= 1279 && document.getElementsByClassName('customer-profile-content-js').length > 0) {
    $('body').on('click', '.customer-profile-content-js nav ul li:not(.to-home-js) a', function(e) {
        e.preventDefault();
        if(document.getElementsByClassName('cp-menu-js').length > 0){
            document.getElementsByClassName('cp-menu-js')[0].style.display = 'block';
        }
        const lis = document.querySelectorAll('.customer-profile-content-js nav ul li');
        for(const li of lis){
            li.classList.add('to-home-js');
        }
    });
    if(document.getElementsByClassName('cp-menu-js').length > 0){
        document.getElementsByClassName('cp-menu-js')[0].style.display = 'block';
    }
    const navLis = document.querySelectorAll('.customer-profile-content-js nav ul li');
    for(const li of navLis){
        li.classList.add('to-home-js');
    }
}

function agreementsInProfile(e) {
    const action = $(e.currentTarget).data('action');
    const key = $(e.currentTarget).data('key');
    const form = $(e.currentTarget).parents('.form-js');
    const data = [];
    const container = $('.consents-js').data('container');
    const template = $('.consents-js').data('template');

    data.push({name: "__csrf", value: __CSRF});
    data.push({name: "__template", value: template});
    data.push({name: "__action", value: action});

    if($(e.currentTarget).hasClass('tos-js')){
        data.push({name: "tos", value: key});
    } else {
        data.push({name: "channelKey", value: key});
    }

    $.post('', data, function(result) {
        app.serverMessage(result, form, e);
        if (result.action.Result) {
            if(result.action.Redirect302 != null){
                app.temporaryPopupMessage(form, __redirectInfo, undefined);
                setTimeout(function () {
                    window.location.assign(result.action.Redirect302);
                }, 3000);
            }
            if (result.action.Redirect302 == null && template != undefined) {
                $(container).html(result.template);
            }
        }
    });
};

$('body').on('click', '.agreements-in-profile-js', function (e) {
    agreementsInProfile(e);
});

function addEmployee(e) {
    const form = $(e.currentTarget).parents('.form-js');
    const error = form.data('error');
    const input = form.find('[name=email]');
    const email = input.val().toLowerCase();
    const userEmail = form.data('email').toLowerCase();
    const employeesEmails = $('.employee-email-js');
    let used = false;
    if(userEmail == email){
        used = true;
    }
    employeesEmails.each(function () {
       if($(this).text().toLowerCase() == email){
           used = true;
       }
    });
    if(used){
        app.temporaryPopupMessage(undefined, error, 'err');
    } else {
        app.post(e, undefined, e);
    }
}

$('body').on('click', '.add-new-employee-js', function(e) {
    addEmployee(e);
});

function addNewAddressInProfile(e) {
    app.delete(e);
    app.scrollToElement(e, '.footer-js');
    
    const containerToDelete = document.querySelector('.container-to-delete-js');
    if (containerToDelete) {
        containerToDelete.remove();
    }
};

$('body').on('click', '.add-new-address-in-profile-js', function(e) {
    app.post(e, addNewAddressInProfile, e, $(e.currentTarget).data('container'));
});

function dsPagerModifier(ds, r) {
    return [...Array(r.PageCount)].map(function(_, i) {
        return {
            No: i + 1,
            Selected: ds.PageNo == i + 1
        };
    })
}

function iconSetter(_index, element) {
    const extension = $(element).data("extension").toLowerCase();
    let iconPath;

    switch (extension) {
        case "jfif":
        case "jpe":
        case "jpeg":
        case "jpg":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-image-' + __iconStyle;
            break;
        case "csv":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-csv-' + __iconStyle;
            break;
        case "doc":
        case "docx":
        case "odt":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-word-' + __iconStyle;
            break;
        case "xls":
        case "xlsx":
        case "ods":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-spreadsheet-' + __iconStyle;
            break;
        case "zip":
        case "rar":
        case "7zip":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-archive-' + __iconStyle;
            break;
        case "pdf":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-pdf-' + __iconStyle;
            break;
        case "txt":
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-alt-' + __iconStyle;
            break;
        default:
            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-' + __iconStyle;
            break;
    }
    const svgUse = $(element).find("use");
    if (svgUse.length) {
        svgUse.attr("xlink:href", iconPath);
    }
}

function getInvoicesTableContent() {
    $.fn.erpData = function() {
        return this.each(function() {
            const div = $(this);
            const table = div.children(".table-js");
            let dateTo;
            if (!table.hasClass("to-download-table-js")) {
                dateTo = $(".get-erp-data-js[name=dateTo]");
                if (window.filterDate) {
                    dateTo.val(window.filterDate)
                }
            }
            const spin = $(".ng-spinner-js");
            const sp = table.data("sp");
            const ds = {
                List: null,
                Pager: null,
                PageNo: 1
            };
            rivets.bind(div, ds);
            function getDateStr(d) {
                return new Date(d - d.getTimezoneOffset() * 6e4).toISOString().slice(0, -14)
            }
            function getDateEl(el) {
                try {
                    const val = el.val();
                    if (val == "") {
                        return null;
                    }
                    const d = new Date(val);
                    el.val(getDateStr(d));
                    return getDateStr(d).replace(/-/g, "")
                } catch (ex) {
                    el.val("");
                    return null
                }
            }

            let currentRequest = null;

            function getData() {
                if (currentRequest && typeof currentRequest.abort === "function") {
                    currentRequest.abort();
                }

                spin.show();

                if ($("[type=date]").val() === "") {
                    const date = new Date().toISOString().slice(0, -14);
                    $("[type=date]").val(date);
                }
                if (window.erpPage) {
                    ds.PageNo = window.erpPage;
                } else {
                    window.erpPage = ds.PageNo;
                }
                
                let parameters;
                if (!table.hasClass("to-download-table-js")) {
                    const dt = getDateEl(dateTo);
                    parameters = {
                        DateTo: dt,
                        LanguageId: __lngId,
                        PageNo: ds.PageNo
                    };
                } else {
                    parameters = {
                        LanguageId: __lngId,
                        PageNo: ds.PageNo
                    };
                }

                currentRequest = $.post(null, {
                    __action: "sync/exec",
                    __csrf: __CSRF,
                    worker: "erpData",
                    message: JSON.stringify({
                        command: sp,
                        parameters: parameters
                    })
                })
                .done(handleGetDataDone)
                .fail(handleGetDataFail);
            }

            function handleGetDataDone(d) {
                spin.hide();
                if (!d.action.Result) {
                    if (d.action.Code !== 0) {
                        app.temporaryPopupMessage(undefined, d.action.Message, d.action.Type);
                    }
                    return;
                }
                const r = d.action.Object[0];
                ds[r.Name] = r.Result;
                ds.Pager = dsPagerModifier(ds, r);
                if (r.PageCount > 1) {
                    ds.FewPages = true;
                }
                const elements = r.Result;
                const elementsQuantity = elements.length;

                for (let i = 0; i < elementsQuantity; i++) {
                    if (elements[i].DaysAfterDueDate > 0 && (elements[i].ToPay > 0 || elements[i].ToReturn < 0)) {
                        elements[i].DaysAfterExists = true;
                    }
                    if (elements[i].ToPay > 0) {
                        elements[i].ToPayExists = true;
                        $(".to-pay-column-js").removeClass("hidden-js");
                    }
                    if (elements[i].ToReturn > 0) {
                        elements[i].ToReturnExists = true;
                        $(".to-pay-column-js").removeClass("hidden-js");
                    }
                    if (elements[i].DeliveryStatus === 0) {
                        elements[i].DeliveryStatus0 = true;
                    }
                    if (elements[i].DeliveryStatus === 1) {
                        elements[i].DeliveryStatus1 = true;
                    }
                    if (elements[i].DeliveryStatus === 2) {
                        elements[i].DeliveryStatus2 = true;
                    }
                    if (elements[i].DeliveryStatus === 3) {
                        elements[i].DeliveryStatus3 = true;
                    }
                    if (elements[i].DeliveryStatus === 4) {
                        elements[i].DeliveryStatus4 = true;
                    }
                    if (elements[i].PaymentStatus === 0) {
                        elements[i].PaymentStatus0 = true;
                    }
                    if (elements[i].PaymentStatus === 1) {
                        elements[i].PaymentStatus1 = true;
                    }
                    if (elements[i].PaymentStatus === 2) {
                        elements[i].PaymentStatus2 = true;
                    }
                    if (hasAnyStatus(elements[i])) {
                        elements[i].StatusExists = true;
                    }
                    if (hasDeliveryStatus(elements[i].DeliveryStatus)) {
                        elements[i].DeliveryStatusExists = true;
                    }
                    if (hasPaymentStatus(elements[i].PaymentStatus)) {
                        elements[i].PaymentStatusExists = true;
                        $(".payment-status-js").removeClass("hidden-js");
                    }
                    if (elements[i].DeliveryStatusExists && elements[i].PaymentStatusExists) {
                        elements[i].DeliveryAndPaymentStatusExists = true;
                    }
                }
                div.find(".page-count-js").text(r.PageCount);
                div.find(".current-page-js").text(r.PageNo);
                if (ds.PageNo === r.PageCount) {
                    $(".pager-js .next-js").attr("disabled", true);
                } else {
                    $(".pager-js .next-js").removeAttr("disabled");
                }
                if (ds.PageNo === 1) {
                    $(".pager-js .prev-js").attr("disabled", true);
                } else {
                    $(".pager-js .prev-js").removeAttr("disabled");
                }
                $(".pager-js [type=number]").val(ds.PageNo);
                if (table.hasClass("to-download-table-js")) {
                    $(".file-to-download-icon-js").each(iconSetter);
                }
                if (elements.length > 0) {
                    table.show();
                    div.find('.pager-js').css('display', 'inline-flex');
                    $('.no-data').hide();
                } else {
                    table.hide();
                    div.find('.pager-js').css('display', 'none');
                    $('.no-data').show();
                }
            }

            function handleGetDataFail() {
                spin.hide();
            }

            // Helper functions to reduce conditional operators
            function hasDeliveryStatus(status) {
                return [0, 1, 2, 3, 4].includes(status);
            }
            function hasPaymentStatus(status) {
                return [0, 1, 2].includes(status);
            }
            function hasAnyStatus(element) {
                return hasDeliveryStatus(element.DeliveryStatus) || hasPaymentStatus(element.PaymentStatus);
            }

            div.on("click", ".pager-js a", function() {
                const no = parseInt($(this).text());
                if (no != ds.PageNo) {
                    ds.PageNo = no;
                    window.erpPage = ds.PageNo;
                    getData()
                }
            });
            div.on("click", ".pager-js button:not([disabled])", function() {
                if ($(this).hasClass("prev-js")) {
                    ds.PageNo = ds.PageNo - 1;
                    window.erpPage = ds.PageNo;
                    getData();
                }
                if (!$(this).hasClass("prev-js") && $(this).hasClass("next-js")) {
                    ds.PageNo = ds.PageNo + 1;
                    window.erpPage = ds.PageNo;
                    getData();
                }
            });
            div.on("keydown", ".pager-js input", function(e) {
                const inputVal = Number($(e.currentTarget).val());
                const max = Number($(".page-count-js").text());
                if (e.keyCode == 13) {
                    if (inputVal != ds.PageNo && inputVal >= 1 && inputVal <= max) {
                        ds.PageNo = inputVal;
                        window.erpPage = ds.PageNo;
                        getData()
                    } else {
                        if (inputVal < 1) {
                            ds.PageNo = 1;
                            window.erpPage = ds.PageNo;
                            getData()
                        }
                        if (inputVal > 0 && inputVal > max) {
                            ds.PageNo = max;
                            window.erpPage = ds.PageNo;
                            getData()
                        }
                    }
                }
            });
            $("body").on("change", ".get-erp-data-js", function() {
                ds.PageNo = 1;
                window.erpPage = ds.PageNo;
                window.filterDate = $(".get-erp-data-js[name=dateTo]").val();
                getData()
            });
            getData();
        })
    };
    $(".erp-data-js").erpData();
}
function erpDataDownloading() {
    if (document.querySelector(".erp-data-js")) {
        document.querySelector(".erp-data-js + .loader-js").style.display = "none";
    }
    if ($("head script[data-riv]").length == 0) {
        fetch("https://cdn.rawgit.com/mikeric/rivets/v0.9.4/dist/rivets.bundled.min.js").then(function(response) {
            if (!response.ok) {
                return false;
            }
            return response.blob()
        }).then(function(myBlob) {
            const objectURL = URL.createObjectURL(myBlob);
            const sc = document.createElement("script");
            sc.setAttribute("src", objectURL);
            sc.setAttribute("data-riv", true);
            sc.setAttribute("type", "text/javascript");
            document.head.appendChild(sc);
            $("head script").last().on("load", function() {
                function getDateStr(d) {
                    return new Date(d - d.getTimezoneOffset() * 6e4).toISOString().slice(0, -14);
                }
                if (typeof rivets !== "undefined") {
                    rivets.binders.bold = function(el, value) {
                        let fontWeight = "normal";
                        let fontSize = "1em";
                        if (value) {
                            fontWeight = "bold";
                            fontSize = "1.2em";
                        }
                        $(el).css({
                            "font-weight": fontWeight,
                            "font-size": fontSize
                        })
                    };
                    rivets.formatters.eq = function(a, b) {
                        return a == b;
                    };
                    rivets.formatters.stringify = function(o) {
                        return JSON.stringify(o);
                    };
                    rivets.formatters.date = function(a) {
                        if (a == "") {
                            return null;
                        }
                        const d = new Date(a);
                        a = getDateStr(d);
                        return a;
                    };
                    rivets.formatters.abs = function(v) {
                        if (v < 0) {
                            return Math.abs(v);
                        }
                        return v;
                    };
                    rivets.formatters.price = function(p, d) {
                        if (p != null) {
                            return p.toPrice(d);
                        }
                        return null;
                    };
                    rivets.formatters.status = function(s) {
                        let statusText;
                        if (s == -1) {
                            statusText = __translations.canceled;
                        } else {
                            if (s == 0) {
                                statusText = __translations.confirmed;
                            }
                            if (s != 0 && (s == 2 || s == 3 || s == 4)) {
                                statusText = __translations.executed;
                            }
                        }
                        return statusText;
                    };
                    rivets.formatters.statusColor = function (status) {
                        if (status == -1) {
                            return __Colors.Error;
                        } else if (status == 2 || status == 3 || status == 4) {
                            return __Colors.Success;
                        } else {
                            return '#0A68CA';
                        }
                    };  
                }
                getInvoicesTableContent();
                if (document.querySelector(".erp-data-js")) {
                    document.getElementsByClassName("erp-data-js")[0].style.display = "block";
                }
            })
        });
    } else {
        getInvoicesTableContent();
        if (document.querySelector(".erp-data-js")) {
            document.getElementsByClassName("erp-data-js")[0].style.display = "block";
        }
    }
};

function changeOrdersSource(e) {
    $(".change-orders-source-js").removeClass("active-js");
    const index = $(e.currentTarget).index();
    $(".change-orders-source-js").eq(index).addClass("active-js");
};

$("body").on("click", ".change-orders-source-js", function(e) {
    app.replaceTemplate(e, undefined, changeOrdersSource, e);
});

function base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

async function downloadErpInvoicePDF() {
    let pdfDownloaded = false;
    let blob = null;
    if(window.erpInvoicePDF){
        for(const invoice of window.erpInvoicePDF){
            if(invoice.id == window.erpInvoiceId){
                pdfDownloaded = true;
                blob = invoice.blob;
            }
        }
    }
    if(pdfDownloaded){
        const a = document.getElementById('erp-invoice-pdf-'+window.erpInvoiceId);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);
    } else {
        const invoicePDFData = {
            __action:'sync/exec',
            worker:'erpData',
            message:JSON.stringify({command:'CDN.eShop_InvoicesPrintoutGet', parameters:{'Id':window.erpInvoiceId}})
        };
        const d = await js.post(invoicePDFData);
        const invoice = d.action.Object[0][0];
        const name = invoice.FileName;
        const binaryString = invoice.FileData;
        const pdfBytes = base64ToArrayBuffer(binaryString);
        const pdfBlob = new Blob([pdfBytes], {type: "octet/stream"});
        const url = window.URL.createObjectURL(pdfBlob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("id", "erp-invoice-pdf-"+window.erpInvoiceId);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
        if(window.erpInvoicePDF){
            window.erpInvoicePDF.push({id:window.erpInvoiceId, blob:pdfBlob});
        } else {
            window.erpInvoicePDF = [{id:window.erpInvoiceId, blob:pdfBlob}];
        }
    }
}

js.delegate(document.body, 'click', '.invoice-pdf-js', downloadErpInvoicePDF);

async function downloadFileFromToDownload() {
    const id = this.dataset.id;
    const extension = this.dataset.extension;
    let fileDownloaded = false;
    let blob = null;
    if(window.downloadedFiles){
        for(const file of window.downloadedFiles){
            if(file.id == id){
                fileDownloaded = true;
                blob = file.blob;
            }
        }
    }
    if(fileDownloaded){
        const a = document.getElementById('file-'+id);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);
    } else {
        const fileData = {
            __action:'sync/exec',
            worker:'erpData',
            message:JSON.stringify({command:'CDN.eShop_GetCustomerBinaryFile', parameters:{'Id':id}})
        };
        const d = await js.post(fileData);
        const file = d.action.Object[0][0];
        const name = file.FileName+'.'+extension;
        const binaryString = file.FileData;
        const fileBytes = base64ToArrayBuffer(binaryString);
        const fileBlob = new Blob([fileBytes], {type: "octet/stream"});
        const url = window.URL.createObjectURL(fileBlob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("id", "file-"+id);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
        if(window.downloadedFiles){
            window.downloadedFiles.push({id:id, blob:fileBlob});
        } else {
            window.downloadedFiles = [{id:id, blob:fileBlob}];
        }
    }
}

js.delegate(document.body, 'click', '.download-file-from-to-download-js', downloadFileFromToDownload);

const copyOrderToCart = async (orderId, hash, inquiry = false) => {
    const data = {
		__action: 'Order/Copy',
		__csrf: __CSRF,
        orderId: orderId,
        hash: hash,
        __template: 'partials/common/header/client-area.html'
    };

    try {
        const response = await $.post('', data);
        const products = response?.action?.Products;
        const notAddedProducts = response?.action.Results;

        if (products?.length > 0) {
            if (inquiry) {
                window.dispatchEvent(new CustomEvent('inquiry:added', {
                    detail: {
                        products: products,
                        failure: notAddedProducts?.length > 0
                    }
                }));
            } else {
                let strategy = __aatc;
                if (notAddedProducts?.length > 0) {
                    strategy = "2";
                }
                window.dispatchEvent(new CustomEvent('cart:added', {
                    detail: {
                        products: products,
                        strategy: strategy
                    }
                }));

                $('.client-area-js').html(response.template);
            }
        }

        const isSingleProductNotAdded =  (!response?.action.Result && response?.action?.Object);
        if (isSingleProductNotAdded || notAddedProducts?.length > 0) {
            window.dispatchEvent(new CustomEvent('validation:failure', {
                detail: {
                    title: __translations.NotCopiedProducts,
                    results: response.action.Results || [response.action]
                }
            }));
            return;
        }
    } catch (error) {
        console.log(error);
    };
};

const cartToInquiry = async (inquiry = true, cartId = null) => {
    try {
        const data = {
            __action: 'Inquiry/Set',
            __csrf: __CSRF,
            inquiry: inquiry,
            __collection: 'customer.Cart.Id' 
        };
        if (cartId) {
            data.cartId = cartId;
        }

        const response = await $.post(null, data);
        const inquiryId = response.collection; 
        app.setCookie('activeInquiryId', inquiryId);

        const data2 = {
            __action: 'Cart/Change',
            __csrf: __CSRF,
            id: -1,
            __template: 'partials/common/header/client-area.html'
        };

        const response2 = await $.post(null, data2);
        $('.client-area-js').html(response2.template);
    } catch (error) {
        console.log(error);
    }
}

$('body').on('click', '.copy-to-cart-js', async (e) => {
    const orderId = $(e.currentTarget).data('id');
    const hash = $(e.currentTarget).data('hash');

    if (!orderId || !hash) {
        return;
    }

    try {
        await copyOrderToCart(orderId, hash);
    } catch (error) {
        console.error('Failed to copy to cart for orderId: ' + orderId + ', hash: ' + hash + ' details: ', error);
    };
});

$('body').on('click', '.copy-to-inquiry-js', async (e) => {
    const cartId = $(e.currentTarget).data('cart-id');
    const orderId = $(e.currentTarget).data('id');
    const hash = $(e.currentTarget).data('hash');

    if (!cartId || !orderId || !hash) {
        return;
    }

    try {
        await js.post({__action: 'Cart/Change', id: cartId});
        await copyOrderToCart(orderId, hash, true);
        await cartToInquiry();
    } catch (error) {
        console.error('Failed to copy to inquiry for orderId: ' + orderId + ', hash: ' + hash + ' details: ', error);
    };
});

function sendComplaint(e) {
    if(app.validationBeforePost(e) != 'error'){
        const form = $(e.currentTarget).parents('.form-js');
        const dataFromHTML = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
        const fileList = window.attachementsInComplaint;
        let filesSize = 0;
        if(fileList != undefined){
            filesSize = fileList.length;
        }
        const fd = new FormData();
        fd.append('__csrf', __CSRF);
        for(const item of dataFromHTML){
            fd.append(item.name, item.value);
        }
        if (form.find('input[name="__action"]').val() === 'Order/ReturnAdd') {
            const qrHash = new URLSearchParams(globalThis.location.search).get('qrHash');
            if (qrHash) {
                fd.append('qrHash', qrHash);
            }
        }
        if (filesSize > 0) {
            window.AttachementsErrors = 0;
            function addAttachementError(file, errorMessage) {
                if(window.AttachementsNotAdded == undefined){
                    window.AttachementsNotAdded = [];
                }
                const attachement = '<div style="padding: 20px;"><strong>'+file.name+'</strong>: '+errorMessage+'</div>';
                window.AttachementsNotAdded.push(attachement);
                window.AttachementsErrors += 1;
            };
            const input = form.find('[name=file]').eq(0);
            const extensions = input.attr('accept').split(', ');
            const fileSize = input.data('file-size');
            let message;
            for (let i=0; i<filesSize; i++) {
                const file = fileList.pop();
                if(file.size < fileSize){
                    const extensionArr = file.name.split('.');
                    const extension = '.' + extensionArr[extensionArr.length - 1].toLowerCase();
                    let wrongExtension = true;
                    for(const ext of extensions){
                        if(extension == ext){
                            fd.append('file'+i, file);
                            wrongExtension = false;
                        }
                    }
                    if(wrongExtension){
                        message = input.data('invalid-file');
                        addAttachementError(file, message);
                    }
                } else {
                    message = input.data('size-exceeded');
                    addAttachementError(file, message);
                }
            }
            if(window.AttachementsNotAdded){
                const popup = '<div class="message-popup-background errors-js cancel-js container-to-delete-js">'+
                            '<div class="popup-container message-popup-on-background-js">'+
                                '<div class="data-form__header">'+
                                    '<span>'+__translations.AttachementsNotAdded+'</span>'+
                                    '<button class="close-button cancel-js" aria-label="'+__translations.Close+'">'+
                                        '<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>'+
                                    '</button>'+
                                '</div>'+
                                '<div class="info">'+
                                    '<div>'+window.AttachementsNotAdded.join('')+'</div>'+
                                '</div>'+
                            '</div>';
                $('body').append(popup);
                const popupMessage = $('.errors-js');
                const closeFunction = () => {
                    popupMessage.find('.cancel-js').click();
                }
                app.setLockFocus(popupMessage, () => closeFunction(), $(document.activeElement));
                window.AttachementsNotAdded = undefined;
                window.AttachementsNotAdded = undefined;
                window.AttachementsErrors = undefined;
            }
        }
        $.ajax({
            data: fd, processData: false, contentType: false, type: 'POST',
            success: function (data) {
                $('.add-attachement-in-complaint-js').val('');
                if (data.action.Result) {
                    const container = form.parents('.add-complaint-form-js');
                    container.find('.success-message-js').removeClass('hidden-js');
                    container.children('.data-form__header').addClass('hidden-js');
                    form.addClass('hidden-js');
                    window.complaints = {};
                    window.complaints['"'+form.find('[name=orderId]').val()+'"'] = {};
                    window.complaints['"'+form.find('[name=orderId]').val()+'"']['"'+form.find('[name=no]').val()+'"'] = form.find('[data-max]').data('max');
                    form.find('input[type="text"], input[type="email"], input[type="tel"], textarea').val('');
                    form.find('.characters-counter-js').addClass('hidden-js');
                    app.formLabelAnimationOnLoadPage();
                } else if (data.action && data.action.Code === 102) {
                    const popup = '<div class="message-popup-background errors-js cancel-js container-to-delete-js">'+
                            '<div class="popup-container message-popup-on-background-js">'+
                                '<div class="data-form__header">'+
                                    '<span>'+__translations.AttachementsNotAdded+'</span>'+
                                    '<button class="close-button cancel-js" aria-label="'+__translations.Close+'">'+
                                        '<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>'+
                                    '</button>'+
                                '</div>'+
                                '<div class="info">'+
                                    '<div>'+data.action.Message+'</div>'+
                                '</div>'+
                            '</div>';
                	$('body').append(popup);
                    const popupMessage = $('.errors-js');
                    const closeFunction = () => {
                        popupMessage.find('.cancel-js').click();
                    }
                    app.setLockFocus(popupMessage, () => closeFunction(), $(document.activeElement));
                } else {
                    app.serverMessage(data, form, e);
                }
                const filesInputs = form.find('input[type=file]');
                for (const fileInput of filesInputs) {
                    $(fileInput).val('');
                    $(fileInput).parent().parent().addClass('hidden-js');
                }
            }
        });
    }
};

$('body').on('click', '.send-complaint-js', function(e) {
    sendComplaint(e);
});


`